/**
 * MOCK DATA — Reconocimientos / Recognition Tracker
 * Sección: Comunidad → Reconocimientos
 * Reemplazar por: consultas a Supabase (stats de agentes, badges, rankings de equipo)
 */
import { BRAND_COLORS } from '../constants/brand';

export const mockPersonalStats = {
  agentName: 'Mario López',
  currentMonth: 'Marzo 2024',
  isAgentOfTheMonth: true,
  pillars: {
    production: {
      label: 'Producción',
      current: 45000,
      target: 50000,
      prefix: '$',
      icon: 'TrendingUp',
      color: BRAND_COLORS.cyan
    },
    training: {
      label: 'Formación',
      current: 12,
      target: 15,
      suffix: ' Módulos',
      icon: 'BookOpen',
      color: BRAND_COLORS.green
    },
    community: {
      label: 'Comunidad',
      current: 850,
      target: 1000,
      suffix: ' Puntos',
      icon: 'Users',
      color: BRAND_COLORS.gold,
      details: '12 Leads • 5 Respuestas FAQ'
    }
  },
  recentBadges: [
    { id: 'b1', title: 'Top Closer', date: 'Feb 2024', icon: 'Target', color: 'bg-brand-cyan' },
    { id: 'b2', title: 'Mentor Activo', date: 'Mar 2024', icon: 'MessageCircle', color: 'bg-brand-gold' },
    { id: 'b3', title: 'Certificación IUL', date: 'Ene 2024', icon: 'Shield', color: 'bg-brand-green' },
  ]
};

export const mockTeamStats = {
  teamName: 'Agencia Alpha',
  leader: 'Carlos Rodríguez',
  totalProduction: 285000,
  totalTrainings: 145,
  members: [
    {
      id: 'm1',
      name: 'Ana López',
      role: 'Agente Senior',
      avatar: 'A',
      stats: { production: 85, training: 100, community: 90 }, // Percentages for mini-bars
      topBadge: { icon: 'Star', color: 'text-brand-gold' }
    },
    {
      id: 'm2',
      name: 'Mario López',
      role: 'Agente Licenciado',
      avatar: 'M',
      stats: { production: 90, training: 80, community: 85 },
      topBadge: { icon: 'Award', color: 'text-brand-cyan' }
    },
    {
      id: 'm3',
      name: 'Daniela Torres',
      role: 'Agente Nueva',
      avatar: 'D',
      stats: { production: 40, training: 95, community: 60 },
      topBadge: { icon: 'BookOpen', color: 'text-brand-green' }
    },
    {
      id: 'm4',
      name: 'Roberto Gómez',
      role: 'Agente Licenciado',
      avatar: 'R',
      stats: { production: 60, training: 50, community: 40 },
      topBadge: null
    }
  ]
};